<template>
  <div v-if="init">
    <LyLoadingBar></LyLoadingBar>
    <el-config-provider :locale="{ ...zhCn, ...plusZhCn }">
      <RouterView/>
      <LyModals></LyModals>
    </el-config-provider>
  </div>
</template>
<script lang="ts" setup>import {RouterView} from 'vue-router'
import {ElConfigProvider} from "element-plus";
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import plusZhCn from 'plus-pro-components/es/locale/lang/zh-cn'
import {LyModals, LyLoadingBar} from "@dh/dh-for-vue";
import {http, initMenu, shareState} from "@dh/dh-for-vue";
import {onMounted, ref} from "vue";
import merchantMenus from "./modules/merchant-menu";

const init = ref(false);
onMounted(async () => {
  const currentUser = await http.get("/institutionAdmin/merchantUser/currentUser");
  shareState.apps = merchantMenus;
  currentUser.data.data.resources = currentUser.data.data.resources.map((item: string) => item.toLowerCase())
  // currentUser.data.data.resources 的数据直接循环从 merchantMenus 中获取所有的code，需要考虑菜单的多级关系
  // const code1 = merchantMenus[0]['menus'].map((item: any) => item.code).filter((item: any) => item !== null && item !== undefined);
  // const code2 = merchantMenus[0]['menus'].flatMap((item: any) => item.children).map((item: any) => item.code).filter((item: any) => item !== null && item !== undefined);
  // currentUser.data.data.resources = [...code1, ...code2];
  shareState.currentUser = currentUser.data.data;
  console.log('shareState', shareState)
  await initMenu();
  let loadDiv = document.getElementById("global-loading");
  if (loadDiv) {
    loadDiv.parentElement!.removeChild(loadDiv!);
  }
  document.getElementById("app")!.style.removeProperty('display');
  init.value = true;
});
</script>
<style scoped>


</style>
